import React from 'react';
interface ApproachCardProps {
  title: string;
  description: string;
  imagePosition: 'left' | 'right';
  imageLabel?: string;
}
const imageMap: Record<string, {
  src: string;
  alt: string;
}> = {
  'Purpose Image 3': {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ejDjpEUKWVJNTg9zBoXb6/Purpose_Image_3.jpg',
    alt: 'Intricate geometric Islamic architectural pattern'
  },
  'Purpose Image 4': {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pK4cc2uJk1j5raCytN65MF/Purpose_Image_4.jpg',
    alt: 'Natural wood grain texture with organic patterns'
  },
  'Purpose Image 5': {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fTBwizBuPmoLskKkVKRCLa/Purpose_Image_5.jpg',
    alt: 'Abstract circular motion pattern with star trails'
  }
};
export const ApproachCard: React.FC<ApproachCardProps> = ({
  title,
  description,
  imagePosition,
  imageLabel = 'Image'
}) => {
  const imageData = imageMap[imageLabel];
  return <div className={`flex flex-col ${imagePosition === 'left' ? 'md:flex-row-reverse' : 'md:flex-row'} md:gap-16 lg:gap-32`} data-id="element-37" data-mp="29c1wsl0vmts3">
      <div className="mb-8 md:mb-0 md:w-1/2 bg-lightgray aspect-[4/3] rounded-lg overflow-hidden flex items-center justify-center" data-id="element-38" data-mp="2ec6eufhfnwkf">
        {imageData ? <img src={imageData.src} alt={imageData.alt} className="w-full h-full object-cover" data-id="element-39" data-mp="2jcklbt3dyygc" /> : <span className="font-inter text-black" data-id="element-40" data-mp="2sa4sfinxjoyv">{imageLabel}</span>}
      </div>
      <div className="md:w-1/2 flex flex-col justify-center" data-id="element-41" data-mp="2x8xwkkhbu3md">
        <h3 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-42" data-mp="320zeon16eokb">
          {title}
        </h3>
        <p className="font-inter text-base leading-relaxed text-black" data-id="element-43" data-mp="370c3hdbly5pj">
          {description}
        </p>
      </div>
    </div>;
};